import { FC } from 'react'
import { BankAccount } from '../models';
import { KTSVG } from '../../../helpers/KTSVG';
import { GenericDropdown } from '../../../hooks/utils/GenericDropdown';

interface Props {
    card: BankAccount
    onEdit: (data: BankAccount) => void
    onDelete: (id: number) => void
}

export const CardGetPaid: FC<Props> = ({ card, onEdit, onDelete }) => {
    return (
        <div className="get-paid-card" data-property-1="others">
            <div className="get-paid-card__left">

                <div className="get-paid-card__icon tap-flex-center">
                    <KTSVG path='/media/svg/nobilis/bank.svg' />
                </div>

                <div className="get-paid-card__info">
                    <div className="get-paid-card__account">{card?.bankName}</div>

                    <div className="get-paid-card__details">
                        <div className="get-paid-card__title">
                            {card?.beneficiary}
                        </div>

                        <div className="get-paid-card__row">
                            <span>Bank Account</span>
                            <span>: {card?.bankName}</span>
                        </div>

                        <div className="get-paid-card__row payment-card__row--muted">
                            <span>SWIFT CODE</span>
                            <span>{card?.swiftCode}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="get-paid-card__right">
                <GenericDropdown
                    options={[
                        { id: 1, label: 'Edit', onClick: () => { onEdit?.(card) } },
                        { id: 2, label: 'Delete', onClick: () => { onDelete?.(Number(card.id)) } },
                    ]}
                    placeholder="⋅⋅⋅"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.id}
                />

                {card?.isPrimary && (<div className="text-card-primary">Primary</div>)}
            </div>
        </div>
    );
}
